import { Status } from './status.enum';

/**
 * Kenobi parameters for a view
 */
export class KenobiParams {
    /**
     * Kenobi param = `fonctionnalite`
     * @type {string}
     */
    public functionality: string;
    /**
     * Kenobi param : `rubrique`
     * @type {string}
     */
    public section: string;
    /**
     * Kenobi param : `commentaire`
     * @type {string}
     */
    public comment: string;
    /**
     * Kenobi param : `offre`
     * @type {string}
     */
    public offer: string;
    /**
     * Kenobi param : `valeurMonetaire`
     * @type {string}
     */
    public price: string;
    /**
     * Kenobi param : `codeRetour`
     * @type {Status}
     */
    public status: Status;
    /**
     * Kenobi param : `ligne`
     * @type {string}
     */
    public line: string;
    /**
     * Kenobi param : `typeLigne`
     * @type {string}
     */
    public lineType: string;

    public constructor(
        functionality: string,
        section: string,
        status: Status,
        options?: {
            comment?: string;
            offer?: string;
            price?: string;
            line?: string;
            lineType?: string;
        },
    ) {
        this.functionality = functionality;
        this.section = section;
        this.status = status;

        if (options) {
            this.comment = options.comment || undefined;
            this.offer = options.offer || undefined;
            this.price = options.price || undefined;
            this.line = options.line || undefined;
            this.lineType = options.lineType || undefined;
        }
    }
}
